// components/StudentForm/StudentDetails.jsx
import React from 'react';
import Select from 'react-select';
import DepartmentSkillsSelector from './DepartmentSkillsSelector';

const locationOptions = [
    { value: 'No Constraint', label: 'No Constraint' },
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Hosur', label: 'Hosur' },
    { value: 'Trichy', label: 'Trichy' },
    { value: 'Madurai', label: 'Madurai' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Gurgaon', label: 'Gurgaon' },
    { value: 'Noida', label: 'Noida' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Ahmedabad', label: 'Ahmedabad' },
    { value: 'Trivandrum', label: 'Trivandrum' },
    { value: 'Coimbatore', label: 'Coimbatore' },
    { value: 'Mohali', label: 'Mohali' },
    { value: 'Indore', label: 'Indore' },
    { value: 'Jaipur', label: 'Jaipur' },
    { value: 'Nagpur', label: 'Nagpur' },
];

const StudentDetails = ({
    formData,
    onDepartmentChange,
    onSkillsChange,
    showToast,
    onFormDataChange,
    locationsData = {},
    trainers = [],
}) => {
    const handleChange = (e) => {
        const { name, value } = e.target;

        onFormDataChange(prev => {
            let updated = { ...prev, [name]: value };

            // ✅ Auto-set placementStatus based on readyForPlacement
            if (name === "readyForPlacement") {

                updated.placementStatus =
                    value === "Yes" ? "Awaiting for placement" : null;

                if (value === "Yes") {
                    // ✅ Set today's date in YYYY-MM-DD format
                    const today = new Date().toISOString().split("T")[0];
                    updated.readyForPlacementDate = today;
                } else {
                    updated.readyForPlacementDate = null;
                }
            }
            return updated;
        });
    };

    const handleLocationChange = (selectedOptions) => {
        const selectedLocations = selectedOptions ? selectedOptions.map(option => option.value) : [];
        onFormDataChange(prev => ({
            ...prev,
            location: selectedLocations
        }));
    };

    const handleStaffChange = (e) => {
        const { name, value } = e.target;

        onFormDataChange(prev => {
            const updatedState = {
                ...prev,
                [name]: value,
            };

            // Auto-fill mentor and staff details when staff is assigned
            if (name === "staffAssigned") {
                const selectedStaff = trainers.find(t => t.emp_name === value);
                if (selectedStaff) {
                    updatedState.mentorName = selectedStaff.emp_name;
                    updatedState.staffAssignedId = selectedStaff.emp_id;
                    updatedState.mentorId = selectedStaff.emp_id;
                    updatedState.mentorNumber = selectedStaff.contact_num;
                } else {
                    updatedState.mentorName = "";
                    updatedState.staffAssignedId = "";
                    updatedState.mentorId = "";
                    updatedState.mentorNumber = "";
                }
            }

            return updatedState;
        });
    };

    // Convert location array to react-select format
    const getSelectedLocations = () => {
        const currentLocations = Array.isArray(formData.location)
            ? formData.location
            : [formData.location].filter(Boolean);

        return locationOptions.filter(option =>
            currentLocations.includes(option.value)
        );
    };

    return (
        <div className="form-section">
            <div className="section-content">
                {/* Name */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Name <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="studentName"
                            value={formData.studentName || ''}
                            onChange={handleChange}
                            className="input"
                        />
                    </div>
                    <div className="form-group">
                        <label className="label">Ready for Placement</label>
                        <select
                            name="readyForPlacement"
                            value={formData.readyForPlacement || 'No'}
                            onChange={handleChange}
                            className="input select"
                        >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div>

                {/* Contact & Email */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Contact Number <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="studentContactNumber"
                            value={formData.studentContactNumber || ''}
                            onChange={handleChange}
                            className="input"
                        />
                    </div>

                    <div className="form-group">
                        <label className="label">Email<span className="mandatory">*</span></label>
                        <input
                            type="email"
                            name="email"
                            onChange={handleChange}
                            value={formData.email || ''}
                            className="input"
                        />
                    </div>
                </div>
                {/* Parent & Gender */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">Ready For Placement Date</label>
                        <input
                            type="date"
                            name="readyForPlacementDate"
                            value={formData.readyForPlacementDate || ""}
                            onChange={handleChange}
                            disabled={formData.readyForPlacement !== "Yes"}
                            className="input"
                            style={{
                                backgroundColor:
                                    formData.readyForPlacement === "Yes"
                                        ? "#ffffff"
                                        : "#f5f5f5",
                                cursor:
                                    formData.readyForPlacement === "Yes"
                                        ? "pointer"
                                        : "not-allowed"
                            }}
                        />
                    </div>

                    <div className="form-group">
                        <label className="label">Created Date</label>
                        <input
                            type="text"
                            value={
                                formData.createdAt
                                    ? new Date(formData.createdAt).toLocaleDateString("en-GB", {
                                        timeZone: "Asia/Kolkata"
                                    })
                                    : ""
                            }
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>

                </div>

                {/* DOB & Address */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Date of Birth
                        </label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob || ""}
                            onChange={handleChange}
                            className="input"
                        />
                    </div>

                    <div className="form-group">
                        <label className="label">
                            Address
                        </label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address || ''}
                            onChange={handleChange}
                            className="input"
                        />
                    </div>
                </div>
                {/* Student Progress Status */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Course Completion Status <span className="mandatory">*</span>
                        </label>
                        <select
                            name="studentProgressStatus"
                            value={formData.studentProgressStatus || 'Course In Progress'}
                            onChange={handleChange}
                            required
                            className="input select"
                        >
                            <option value="Course In Progress">Course In Progress</option>
                            <option value="Course Completed">Course Completed</option>
                            <option value="Discontinued">Discontinued</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="label">
                            Gender <span className="mandatory">*</span>
                        </label>
                        <select
                            name="gender"
                            value={formData.gender || ""}
                            onChange={handleChange}
                            className="input select"
                            required
                        >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>

                </div>

                {/* Desired Location - Multi-Select */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">Preferred Job Location</label>
                        <Select
                            isMulti
                            name="location"
                            options={locationOptions}
                            value={getSelectedLocations()}
                            onChange={handleLocationChange}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Select Preferred job locations..."
                        />
                    </div>

                    <div className="form-group">
                        <label className="label">
                            Branch <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="branch"
                            value={formData.branch || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                </div>

                {/* Department & Skills */}
                <div className="form-row">
                    <div className="form-group full-width">
                        <DepartmentSkillsSelector
                            department={formData.Department}
                            skillsKnown={formData.skillsKnown}
                            onDepartmentChange={onDepartmentChange}
                            onSkillsChange={onSkillsChange}
                            showToast={showToast}
                            departmentRequired={true}
                            skillsRequired={true}
                            layout="horizontal"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentDetails;